import { axiosGet, axiosPost } from "../../react_axios/Axios";
import { GET_VENDOR_CONFIGURATION_LIST,GET_VENDOR_CONFIGURATION_DETAIL,INSERT_VENDOR_CONFIGURATION,getVendorConfigurationListUrl,getVendorConfigurationDetailUrl,insertVendorConfigurationUrl,raiseManualFormInvoiceUrl,markManualFormInvoicePaidUrl, headers, getVendorBasicDetailUrl, GET_VENDOR_BASIC_DETAIL, getVendorStaticListUrl,getVendorDashboardDataUrl, GET_VENDOR_STATIC_LIST, GET_VENDOR_DASHBOARD_DATA } from '../../utils/constants'
import { GET_VENDOR_EXHIBITOR_LIST, getVendorExhibitorListUrl } from "../../utils/constants";


export const getVendorConfigurationList_action = (ExhibitionID,VendorID,StallTypeID,IsBare,IsShell,BareArea,ShellArea,IsNational,IsInternational) => async (dispatch) => {

    try {
        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID !='' ? ExhibitionID: null,
            VendorID: VendorID !='' ? VendorID: null,
            StallTypeID: StallTypeID !='' ? StallTypeID: null,
            IsBare: IsBare !='' ? IsBare: null,
            IsShell: IsShell !='' ? IsShell: null,
            BareArea: BareArea !='' ? BareArea: null,
            ShellArea: ShellArea !='' ? ShellArea: null,
            IsNational: IsNational !='' ? IsNational: null,
            IsInternational: IsInternational !='' ? IsInternational: null
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getVendorConfigurationListUrl, mapdata, headers);

        dispatch({
            type: GET_VENDOR_CONFIGURATION_LIST,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const getVendorExhibitorList_action = (ExhibitionID, VendorID, ServiceId, StatusID) => async (dispatch) => {

    try {
        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID !='' ? ExhibitionID: null,
            VendorID: VendorID !='' ? VendorID: null,
            ServiceId: ServiceId !='' ? ServiceId: null,
            StatusID: StatusID !='' ? StatusID: 0
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getVendorExhibitorListUrl, mapdata, headers);

        dispatch({
            type: GET_VENDOR_EXHIBITOR_LIST,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVendorConfigurationDetail_action = (ExhibitionID,VendorID,StallTypeID,IsBare,IsShell,BareArea,ShellArea,IsNational,IsInternational) => async (dispatch) => {

    try {
        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID !='' ? ExhibitionID: null,
            VendorID: VendorID !='' ? VendorID: null,
            StallTypeID: StallTypeID !='' ? StallTypeID: null,
            IsBare: IsBare !='' ? IsBare: null,
            IsShell: IsShell !='' ? IsShell: null,
            BareArea: BareArea !='' ? BareArea: null,
            ShellArea: ShellArea !='' ? ShellArea: null,
            IsNational: IsNational !='' ? IsNational: null,
            IsInternational: IsInternational !='' ? IsInternational: null
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getVendorConfigurationDetailUrl, mapdata, headers);

        dispatch({
            type: GET_VENDOR_CONFIGURATION_DETAIL,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const insertVendorConfiguration_action = (vendorMapping, vendorCOnfiguration) => async (dispatch) => {
    try {
        const params = {
            vendorMapping: vendorMapping,
            vendorCOnfiguration: vendorCOnfiguration
        }

        const res = await axiosPost(insertVendorConfigurationUrl, params, headers)

        dispatch({
            type: INSERT_VENDOR_CONFIGURATION,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}
